__turbopack_context__.v({
  "accordionSlideOverwrite": "loadingSpinner-module-scss-module__WvyecW__accordionSlideOverwrite",
  "fadeIn": "loadingSpinner-module-scss-module__WvyecW__fadeIn",
  "fadeOut": "loadingSpinner-module-scss-module__WvyecW__fadeOut",
  "large": "loadingSpinner-module-scss-module__WvyecW__large",
  "loadingSpinner": "loadingSpinner-module-scss-module__WvyecW__loadingSpinner",
  "medium": "loadingSpinner-module-scss-module__WvyecW__medium",
  "rotation": "loadingSpinner-module-scss-module__WvyecW__rotation",
  "scaleIn": "loadingSpinner-module-scss-module__WvyecW__scaleIn",
  "scaleOut": "loadingSpinner-module-scss-module__WvyecW__scaleOut",
  "small": "loadingSpinner-module-scss-module__WvyecW__small",
  "stretchContainer": "loadingSpinner-module-scss-module__WvyecW__stretchContainer",
  "zoomIn": "loadingSpinner-module-scss-module__WvyecW__zoomIn",
  "zoomOut": "loadingSpinner-module-scss-module__WvyecW__zoomOut",
});
